
import Api from "@/services/Api";
import { computed, defineComponent, onMounted, ref, Ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Modal } from "bootstrap";
import Title from "@/components/Title.vue";
import Button from "@/components/Button.vue";
// import ModalCreateEditBandeira from "./components/ModalCreateEditBandeira.vue";
import useEmitter from "@/composables/Emmiter";
import ModalEditPlanoLojaVue from "./components/ModalEditPlanoLoja.vue";
import moment from 'moment';
import Pagination from "@/components/Pagination.vue";
import _Skeleton from "element-plus/lib/el-skeleton";

interface LojaPlano {
  codConcessionaria: number | null;
  dataFim: string;
  dataInicio: string;
  id: number | null;
  idPlano: number | null;
  nome: string;
  nomeFantasia: string;
  status: string;
  limiteMensalBuscaPlaca: number | null;
  saldoBuscaPlaca: number | null;
  cnpj: string | null;
}

export default defineComponent({
  name: "Planos",
  components: {Title, Button, ModalEditPlanoLojaVue, Pagination},
  props: [],
  setup() {
    const router = useRouter();
    const route = useRoute();
    const paramsProdutos: Ref<any> = ref({ pagina: 1, limite: 20, input: '' })
    const emitter = useEmitter()
    const auxModal: Ref<any> = ref(null);
    const lojasSelect: Ref<LojaPlano[]> = ref([]);
    const planosSelect: Ref<any> = ref([]);
    const lojasWithPlans: Ref<LojaPlano[]> = ref([]);
    const lojaPlanoSelected: Ref<LojaPlano> = ref({
        codConcessionaria: null,
        dataFim: '',
        dataInicio: '',
        id: null,
        idPlano: null,
        nome: '',
        nomeFantasia: '',
        status: '',
        limiteMensalBuscaPlaca: null,
        saldoBuscaPlaca: null,
        cnpj: ''
    });
    const filtroPlano = ref()
    const filtroLoja = ref()
    const paramsFilter: Ref<LojaPlano> = ref({
        codConcessionaria: null,
        dataFim: '',
        dataInicio: '',
        id: null,
        idPlano: null,
        nome: '',
        nomeFantasia: '',
        status: '',
        limiteMensalBuscaPlaca: null,
        saldoBuscaPlaca: null,
        cnpj: ''
    })
    const totalLojasWithPlans: Ref<number> =ref(0)
    const inputFind: Ref<string> = ref('')
    const page: Ref<number> = ref(1)
    const limite: Ref<number> = ref(10);
    const pagination = ref<InstanceType<typeof Pagination> | null>(null);
    const skeleton: Ref<boolean> = ref(false);

    async function getAllPlans(pageParam: number, limite: number, paramsFilter: LojaPlano) {

      const addDate = {dataInicial_01: '',dataInicial_02: '',dataFinal_01: '',dataFinal_02: ''}
      
      if(paramsFilter.dataFim && paramsFilter.dataFim.length){
        addDate.dataFinal_01 = formatarDataParaBanco(paramsFilter.dataFim[0])
        addDate.dataFinal_02 = formatarDataParaBanco(paramsFilter.dataFim[1])
      }
      if(paramsFilter.dataInicio && paramsFilter.dataInicio.length){
        addDate.dataInicial_01 = formatarDataParaBanco(paramsFilter.dataInicio[0])
        addDate.dataInicial_02 = formatarDataParaBanco(paramsFilter.dataInicio[1])
      }
      if(paramsFilter.cnpj && paramsFilter.cnpj.length){
        paramsFilter.cnpj = paramsFilter.cnpj.replace(/[^\d]/g, '');
      }

      const novoParamsFilter = { ...paramsFilter, ...addDate };

      try {
        skeleton.value = true
        const { data } = await Api.post("getAllPlansPag", {pagina: pageParam, limite, paramsFilter: novoParamsFilter});
        skeleton.value = false
        lojasWithPlans.value = data.original.lojasWithPlans;
        totalLojasWithPlans.value = data.original.totalLojasComPlanos;        
      } catch (error) {
        console.log(error);
      }
    }

    async function getAll() {
        try {
            const { data } = await Api.get("getAllPlans");
            lojasSelect.value = data;
        } catch (error) {
        console.log(error);
      }
    }

    async function getAllPlanosLoja() {
        try {
            const { data } = await Api.get("getAllPlanosLoja");
            planosSelect.value = data;
        } catch (error) {
        console.log(error);
      }
    }

    async function clickedLojaPlan(id: number | null) {
      try {
        const {data} = await Api.get('getLojaWithPlans', {idPlanoConcessionaria: id})
        lojaPlanoSelected.value = data   
      } catch (error) {
        console.log(error)
      }
    }
    
    const openModal = (id: string) => {
      const auxElement = document.querySelector(`#${id}`);
      auxModal.value = new Modal(auxElement);
      auxModal.value.show();
    };
    
    function closeModal(): void {
      auxModal.value.hide()
      auxModal.value = null
      getAllPlans(page.value, limite.value, paramsFilter.value)
    }

    emitter.on("paramsFilter", (valor: any) => {
      paramsFilter.value = valor.paramsFilter
    })

    function formatarDataParaBanco(data: any) {
      return moment(data).format('YYYY-MM-DD HH:mm:ss');
    } 

    function formatarDataParaTemplate(data: any) {
      return moment(data).format('DD/MM/YYYY');
    } 

    function handlePageChange(pageParam) {    
      page.value = pageParam;
      getAllPlans(page.value, limite.value, paramsFilter.value);
    }

    /*
    watch(
      () => state.value.currentPage,
      () => getAllPlans(page.value, limite.value, paramsFilter.value)
    )
    */
    watch(
      () => paramsFilter.value,
      () => {
        page.value = 1;
        if (pagination.value) {
              pagination.value.resetPage(1);
            }
            getAllPlans(page.value, limite.value, paramsFilter.value)
      }, {deep: true}
    )
    
    onMounted(() => {getAllPlans(page.value, limite.value, paramsFilter.value), getAll(), getAllPlanosLoja()})
    
    return { lojasWithPlans, lojasSelect, paramsFilter, filtroLoja, planosSelect, filtroPlano, formatarDataParaTemplate, clickedLojaPlan, totalLojasWithPlans, inputFind, openModal, closeModal, lojaPlanoSelected , getAllPlans, route, handlePageChange, pagination, skeleton};
    
  },
});
